var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4998 0.30603C4.9934 0.30603 0.509766 4.57456 0.509766 9.82247C0.509766 14.9398 9.79204 26.0151 10.1889 26.4803C10.2666 26.5742 10.3811 26.6272 10.4998 26.6272C10.6225 26.6272 10.737 26.5742 10.8148 26.4803C11.2075 26.0151 20.4898 14.9398 20.4898 9.82247C20.4898 4.57456 16.0102 0.30603 10.4998 0.30603ZM10.4998 16.7547C6.47088 16.7547 3.20842 13.6493 3.20842 9.82239C3.20842 5.99162 6.47088 2.88616 10.4998 2.88616C14.5288 2.88616 17.7952 5.99162 17.7952 9.82239C17.7952 13.6493 14.5288 16.7547 10.4998 16.7547Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.996 12.7076L13.826 7.1332C13.7114 6.59454 13.2287 6.20278 12.6724 6.20278H12.386L12.3042 5.57842C12.1896 4.67656 11.4124 3.99915 10.5001 3.99915C9.5919 3.99915 8.81463 4.67656 8.69599 5.57842L8.61418 6.20278H8.32781C7.77554 6.20278 7.28872 6.59454 7.17827 7.1332L6.00827 12.7076C5.85449 13.4321 6.4059 14.1195 7.15781 14.1195H13.8464C14.5978 14.1195 15.1499 13.4326 14.996 12.7076ZM9.50599 5.68456C9.57145 5.1867 10.001 4.81535 10.5001 4.81535C11.0033 4.81535 11.4287 5.1867 11.4942 5.68456L11.5596 6.20282H9.44054L9.50599 5.68456Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActive);
export default __webpack_public_path__ + "static/media/homeActive.ffc6cafc744bfdbc8c227158a7da4881.svg";
export { ForwardRef as ReactComponent };